/**
 * Acesso ao texto de interface — DESIGN_SYSTEM §9.5.
 *
 * "Todo texto de interface fica em `packages/ui/content/*.pt-BR.json`, com chaves semanticas.
 * Texto em JSX e erro de lint."
 *
 * i18n **nao** esta no MVP (publico monolingue), mas a estrutura de chaves ja permite
 * adicionar depois sem refatorar — por isso o acesso e por funcao, e nao por import direto do
 * JSON espalhado pelos componentes.
 */

import textos from './ui.pt-BR.json';

/** As chaves existentes, derivadas do proprio JSON: chave errada nao compila. */
export type ChaveDeTexto = Exclude<keyof typeof textos, '$comentario'>;

const DICIONARIO: Readonly<Record<string, string>> = textos;

/**
 * Interpola `{parametro}`. Sem biblioteca de template: uma substituicao de chaves entre
 * chaves-simples e tudo de que o MVP precisa, e nao carrega KB para a rota de entrada
 * (§10.7).
 */
export function t(chave: ChaveDeTexto, parametros: Readonly<Record<string, string | number>> = {}): string {
  const bruto = DICIONARIO[chave];
  if (bruto === undefined) {
    throw new Error(`Chave de texto inexistente: ${chave} (DESIGN_SYSTEM §9.5).`);
  }
  return bruto.replace(/\{(\w+)\}/g, (inteiro, nome: string) => {
    const valor = parametros[nome];
    return valor === undefined ? inteiro : String(valor);
  });
}

/** Todas as chaves — usado pelo teste que garante que nenhum texto ficou em JSX. */
export function chavesDeTexto(): readonly string[] {
  return Object.keys(DICIONARIO).filter((chave) => chave !== '$comentario');
}
